<template>
  <div class="news bg">
    <div class="banner-div">
      <img :src="require(`@/assets/images/${languages}/news/banner.jpg`)">
    </div>
    <div class="main-box">
      <div class="news-list-box">
        <h3 class="news-title">{{languagesData.newDetails.newsList[id].title}}</h3>
        <div class="time-box">
          <p><span class="time-text">{{languagesData.newDetails.newsList[id].time}}</span><span class="time-bg"></span>
          </p>
        </div>
        <div class="news-text" v-html="languagesData.newDetails.newsList[id].content"></div>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  export default {
    data() {
      return {
        resDatas: '',
        id: this.$route.query.id
      }
    },
    computed: {
      ...mapState(["languages", "languagesData"]), // 在这里引入你需要的state值
    },
    methods: {

    },
    mounted() {
      this.$store.state.highlight = 'news';
    }
  }
</script>

<style scoped>
  .main-box {
    width: 100%;
    overflow: hidden;
    position: relative;
    background: url('~@/assets/images/traditional/news/bg2.jpg') top no-repeat;
    background-size: 100% 100%;
  }

  .news-list-box {
    text-align: center;
  }

  .news-list {
    margin-bottom: 100px;
    display: block;
  }

  .news-title {
    color: #6b4982;
    font-size: 35px;
    word-break: break-all;
  }

  .time-box {
    position: relative;
    text-align: center;
  }

  .time-box p {
    display: inline-block;
    position: relative;
    padding: 0 3%;
    margin-top: 2%;
  }

  .time-box .time-text {
    font-size: 24px;
    color: #6b4982;
    display: inline-block;
    z-index: 1;
    position: relative;
  }

  .time-box .time-bg {
    background-color: #d9c7ff;
    height: 20px;
    width: 100%;
    background-color: #d9c7ff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 15px;
  }

  .news-text {
    margin: 3% auto 0;
    width: 76%;
    text-align: left;
  }

  @media screen and (max-width: 1000px) {
    .news-list-box {
      width: 90%;
      margin: auto;
    }

    .news-list {
      margin-bottom: 10%;
    }

    .news-list img {
      max-width: 100%;
    }

    .news-text {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newDetails.vue